import React from "react";

import { Checkbox } from "../../atoms";
import { Box } from "../../cores";
import { IKeyStringAndValue } from "../../types/Types";

interface ISelectFilter {
  id: string;
  filter: string;
  setFilterOptions: React.Dispatch<React.SetStateAction<IKeyStringAndValue>>;
  filterOptions: IKeyStringAndValue;
}
export default function CheckboxFilter({
  id,
  filter,
  setFilterOptions,
  filterOptions,
}: ISelectFilter) {
  const isItChecked = Object.entries(filterOptions).some((a) => {
    return (a[0] === filter && a[1] === "1") ||
      (a[0] === filter && a[1] === "Hant") ||
      (a[0] === filter && a[1] === "J") ||
      (a[0] === filter && a[1] === "3")
      ? true
      : false;
  });

  const handleChange = () => {
    setFilterOptions({
      ...filterOptions,
      [filter]:
        !isItChecked && filter === "artisan_car"
          ? "Hant"
          : (!isItChecked && filter === "safest_choice") ||
            (!isItChecked && filter === "good_choise")
          ? "J"
          : (!isItChecked && filter === "backsensor") ||
            (!isItChecked && filter === "backcamera")
          ? "3"
          : !isItChecked
          ? "1"
          : "default",
    });
  };
  return (
    <Box sx={{ marginRight: "sm" }}>
      <Checkbox
        key={id}
        id={filter}
        checked={isItChecked}
        onChange={handleChange}
        //@ts-ignore Incorrect type in Folksam UI
        testId={id}
      />
    </Box>
  );
}
